export const CARGAR_SOLI = "CARGAR_SOLI";
export const MODIFICAR_SOLI = "MODIFICAR_SOLI";
export const GUARDAR_SOLICITUD = "GUARDAR_SOLICITUD";
export const CARGANDO_ADD = "CARGANDO_ADD";
export const ERROR_ADD = "ERROR_ADD";
export const SELECCIONAR_FILE = "SELECCIONAR_FILE";
export const ELIMINAR_FILE = "ELIMINAR_FILE";
export const ERROR = "ERROR"; 
export const LIMPIAR_ERROR = "LIMPIAR_ERROR";